module.exports = {
    // API: 'http://localhost:5003',
    API: 'https://clockitin.devworks-solutions.com',
    COLORS: {
        primary: '#20c997',
        secondary: "#c29873"
        
    }
}